var render = function render(){var _vm=this,_c=_vm._self._c;return _vm._m(0)
}
var staticRenderFns = [function (){var _vm=this,_c=_vm._self._c;return _c('div',{attrs:{"id":"load-wraper"}},[_c('div',{staticClass:"load-item"},[_c('div',{staticClass:"load-book"},[_c('div',{staticClass:"load-book-page"})]),_c('span',{staticClass:"load-item-span textColorDarkBlack mt-3 absolute"},[_vm._v("Loading")])])])
}]

export { render, staticRenderFns }